export default {"src":"/_next/static/media/hamburger-logo.11589161.svg","height":20,"width":21,"blurWidth":0,"blurHeight":0};